import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';

// API Actions
const DUPLICATE_INITIATIVE_REQUEST =
  'changesync/initiativeDuplications/DUPLICATE_INITIATIVE_REQUEST';
const DUPLICATE_INITIATIVE_SUCCESS =
  'changesync/initiativeDuplications/DUPLICATE_INITIATIVE_SUCCESS';
const DUPLICATE_INITIATIVE_FAILURE =
  'changesync/initiativeDuplications/DUPLICATE_INITIATIVE_FAILURE';
const RETRIEVE_PREVIEW_REQUEST =
  'changesync/initiativeDuplications/RETRIEVE_PREVIEW_REQUEST';
const RETRIEVE_PREVIEW_SUCCESS =
  'changesync/initiativeDuplications/RETRIEVE_PREVIEW_SUCCESS';
const RETRIEVE_PREVIEW_FAILURE =
  'changesync/initiativeDuplications/RETRIEVE_PREVIEW_FAILURE';

// UI Actions
const HIDE_COPY_TOAST = 'changesync/initiativeDuplications/HIDE_COPY_TOAST';
const CLEAR_COPY = 'changesync/initiativeDuplications/CLEAR_COPY';

// Initial State
const initialState = {
  /**
   * The copy made last, kept while the user stays on the page it was made on:
   * the list highlights it and the success message offers to open it.
   * @type {{ id: number, type: string, title: string, projectId: number,
   *   projectName: string, sourceId: number, sourceProjectId: number, path: string } | null}
   */
  copy: null,
  toastShown: false,
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case DUPLICATE_INITIATIVE_SUCCESS:
      return {
        copy: {
          id: action.payload.id,
          type: action.payload.type,
          title: action.payload.title,
          projectId: action.payload.projectId,
          projectName: action.payload.project?.name,
          ...action.meta,
        },
        toastShown: true,
      };
    case HIDE_COPY_TOAST:
      return { ...state, toastShown: false };
    case CLEAR_COPY:
      return initialState;
    default:
      return state;
  }
};

// Action Creators

/**
 * @param {{ id: number, type: string }} initiative source
 * @param {number} sourceProjectId project of the source
 * @param {{ projectId: number, initiative: { title: string }, sections: string[] }} payload
 */
export const duplicateInitiative = (initiative, sourceProjectId, payload) => ({
  [CALL_API]: {
    types: [
      DUPLICATE_INITIATIVE_REQUEST,
      DUPLICATE_INITIATIVE_SUCCESS,
      DUPLICATE_INITIATIVE_FAILURE,
    ],
    endpoint: `${initiative.type}_initiatives/${initiative.id}/duplicate`,
    method: HTTP_METHODS.POST,
    body: payload,
  },
  meta: {
    sourceId: initiative.id,
    sourceProjectId,
    path: window.location.pathname,
  },
});

/**
 * What a copy into `projectId` would change there: the owner and the stakeholders to add.
 * Changes nothing on the server.
 */
export const retrieveDuplicationPreview = (type, id, projectId) => ({
  [CALL_API]: {
    types: [
      RETRIEVE_PREVIEW_REQUEST,
      RETRIEVE_PREVIEW_SUCCESS,
      RETRIEVE_PREVIEW_FAILURE,
    ],
    endpoint: `${type}_initiatives/${id}/duplication_preview`,
    method: HTTP_METHODS.GET,
    query: { projectId },
  },
});

export const hideInitiativeCopyToast = () => ({ type: HIDE_COPY_TOAST });

export const clearInitiativeCopy = () => ({ type: CLEAR_COPY });

// Selectors

export const selectInitiativeCopy = (state) =>
  state.initiativeDuplications.copy;

export const selectInitiativeCopyToastShown = (state) =>
  state.initiativeDuplications.toastShown;
